import { useEffect, useState } from 'react'

export function useYouTubeAPI() {
  const [apiReady, setApiReady] = useState(!!window.YT)

  useEffect(() => {
    if (window.YT) {
      setApiReady(true)
      return
    }

    // Save the original callback if it exists
    const originalCallback = window.onYouTubeIframeAPIReady

    // Set up our callback
    window.onYouTubeIframeAPIReady = () => {
      if (originalCallback) {
        originalCallback()
      }
      setApiReady(true)
    }

    // Load the script
    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag)

    return () => {
      // Restore original callback on cleanup
      window.onYouTubeIframeAPIReady = originalCallback
    }
  }, [])

  return apiReady
}
